export default {
  sidebar: {
    config: 'Configuración',
    templates: 'Plantillas',
  },
};
